import Head from "next/head";

export default function AuthorSchema({ data }) {
  const authors = Array.isArray(data) ? data : [data];

  if (!authors.length) {
    return null;
  }
  const authorSchemas = authors.map((author) => ({
    "@type": "Person",
    "name": author?.field_author_full_name?.[0]?.value || "Author name",
    "jobTitle": author?.field_job_title?.[0]?.value || "Job title",
    "description": author?.field_slug?.[0]?.value || "Author description.",
    "url": author?.field_author_site?.[0]?.value,
    "worksFor": {
      "@type": "Organization",
      "name": author?.field_organization_name?.[0]?.value || "Digital Realty",
      "url": author?.field_organization_url?.[0]?.value || "https://www.digitalrealty.com",
    },
  }));

  const schema = {
    "@context": "https://schema.org",
    "@type": "Article",
    "author": authorSchemas.length === 1 ? authorSchemas[0] : authorSchemas,
  };

  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(schema, null, 2),
        }}
      />
    </Head>
  );
}
